export const button = {
  defaultProps: {
    variant: "gradient",
    size: "md",
    color: "gray",
    fullWidth: false,
    ripple: true,
    className: "flex",
  },
  valid: {
    variants: ["filled", "outlined", "gradient", "text"],
    sizes: ["sm", "md", "lg"],
    colors: [
      "white",
      "blue-gray",
      "gray",
      "brown",
      "deep-orange",
      "orange",
      "amber",
      "yellow",
      "lime",
      "light-green",
      "green",
      "teal",
      "cyan",
      "light-blue",
      "blue",
      "indigo",
      "deep-purple",
      "purple",
      "pink",
      "red",
    ],
  },
  styles: {
    base: {
      initial: {
        verticalAlign: "align-middle",
        userSelect: "select-none",
        fontFamily: "Lato",
        fontWeight: "font-bold",
        textAlign: "text-center",
        textTransform: "capitalize",
        transition: "transition-all",
        disabled:
          "disabled:opacity-50 disabled:shadow-none disabled:pointer-events-none",
      },
      fullWidth: {
        display: "block",
        width: "w-full",
      },
    },
    sizes: {
      sm: {
        fontSize: "text-[14px]",
        py: "py-[6px]",
        px: "px-[12px]",
        borderRadius: "rounded-[6px]",
        lineHeight: "leading-5",
      },
      md: {
        fontSize: "text-[16px] font-semibold",
        py: "py-[8px]",
        px: "px-[16px]",
        borderRadius: "rounded-[6px]",
        lineHeight: "leading-6",
      },
      lg: {
        fontSize: "text-[18px] font-bold",
        py: "py-[12px]",
        px: "px-[24px]",
        borderRadius: "rounded-[6px]",
        lineHeight: "leading-6",
      },
    },
    variants: {
      filled: {
        white: {
          backgroud: "bg-white",
          color: "text-blue-gray-900",
          shadow: "shadow-none",
          hover: "shadow-none",
          focus: "focus:opacity-[0.85] focus:shadow-none",
          active: "active:opacity-[0.85] active:shadow-none",
        },
        "blue-gray": {
          backgroud: "bg-blue-gray-600",
          color: "text-white",
          shadow: "shadow-none",
          hover: "shadow-none",
          focus: "focus:opacity-[0.85] focus:shadow-none",
          active: "active:opacity-[0.85] active:shadow-none",
        },
        gray: {
          backgroud: "bg-gray-100",
          color: "text-gray-800",
          shadow: "shadow-none",
          font: "font-[400]",
          hover: "shadow-none",
          focus: "focus:opacity-[0.85] focus:shadow-none",
          active: "active:opacity-[0.85] active:shadow-none",
        },
        brown: {
          backgroud: "bg-brown-600",
          color: "text-white",
          shadow: "shadow-none",
          hover: "hoshadow-none",
          focus: "focus:opacity-[0.85] focus:shadow-none",
          active: "active:opacity-[0.85] active:shadow-none",
        },
        "deep-orange": {
          backgroud: "bg-deep-orange-600",
          color: "text-white",
          shadow: "shadow-none",
          hover: "shadow-none",
          focus: "focus:opacity-[0.85] focus:shadow-none",
          active: "active:opacity-[0.85] active:shadow-none",
        },
        orange: {
          backgroud: "bg-orange-600",
          color: "text-white",
          shadow: "shadow-none",
          hover: "shadow-none",
          focus: "focus:opacity-[0.85] focus:shadow-none",
          active: "active:opacity-[0.85] active:shadow-none",
        },
        amber: {
          backgroud: "bg-amber-600",
          color: "text-black",
          shadow: "shadow-none",
          hover: "shadow-none",
          focus: "focus:opacity-[0.85] focus:shadow-none",
          active: "active:opacity-[0.85] active:shadow-none",
        },
        yellow: {
          backgroud: "bg-yellow-600",
          color: "text-black",
          shadow: "shadow-none",
          hover: "shadow-none",
          focus: "focus:opacity-[0.85] focus:shadow-none",
          active: "active:opacity-[0.85] active:shadow-none",
        },
        lime: {
          backgroud: "bg-lime-600",
          color: "text-black",
          shadow: "shadow-none",
          hover: "shadow-none",
          focus: "focus:opacity-[0.85] focus:shadow-none",
          active: "active:opacity-[0.85] active:shadow-none",
        },
        "light-green": {
          backgroud: "bg-light-green-600",
          color: "text-white",
          shadow: "shadow-none",
          hover: "shadow-none",
          focus: "focus:opacity-[0.85] focus:shadow-none",
          active: "active:opacity-[0.85] active:shadow-none",
        },
        green: {
          backgroud: "bg-green-600",
          color: "text-white",
          shadow: "shadow-none",
          hover: "shadow-none",
          focus: "focus:opacity-[0.85] focus:shadow-none",
          active: "active:opacity-[0.85] active:shadow-none",
        },
        teal: {
          backgroud: "bg-primary-500",
          color: "text-white",
          shadow: "shadow-none",
          hover: "shadow-none",
          focus: "focus:opacity-[0.85] focus:shadow-none",
          active: "active:opacity-[0.85] active:shadow-none",
        },
        cyan: {
          backgroud: "bg-cyan-600",
          color: "text-white",
          shadow: "shadow-none",
          hover: "shadow-none",
          focus: "focus:opacity-[0.85] focus:shadow-none",
          active: "active:opacity-[0.85] active:shadow-none",
        },
        "light-blue": {
          backgroud: "bg-light-blue-600",
          color: "text-white",
          shadow: "shadow-none",
          hover: "shadow-none",
          focus: "focus:opacity-[0.85] focus:shadow-none",
          active: "active:opacity-[0.85] active:shadow-none",
        },
        blue: {
          backgroud: "bg-blue-600",
          color: "text-white",
          shadow: "shadow-none",
          hover: "shadow-none",
          focus: "focus:opacity-[0.85] focus:shadow-none",
          active: "active:opacity-[0.85] active:shadow-none",
        },
        indigo: {
          backgroud: "bg-indigo-600",
          color: "text-white",
          shadow: "shadow-none",
          hover: "shadow-none",
          focus: "focus:opacity-[0.85] focus:shadow-none",
          active: "active:opacity-[0.85] active:shadow-none",
        },
        "deep-purple": {
          backgroud: "bg-deep-purple-600",
          color: "text-white",
          shadow: "shadow-none",
          hover: "shadow-none",
          focus: "focus:opacity-[0.85] focus:shadow-none",
          active: "active:opacity-[0.85] active:shadow-none",
        },
        purple: {
          backgroud: "bg-purple-600",
          color: "text-white",
          shadow: "shadow-none",
          hover: "shadow-none hover:bg-purple-700",
          focus: "focus:opacity-[0.85] focus:shadow-none",
          active: "active:opacity-[0.85] active:shadow-none",
        },
        pink: {
          backgroud: "bg-pink-600",
          color: "text-white",
          shadow: "shadow-none",
          hover: "shadow-none",
          focus: "focus:opacity-[0.85] focus:shadow-none",
          active: "active:opacity-[0.85] active:shadow-none",
        },
        red: {
          backgroud: "bg-red-600",
          color: "text-white",
          shadow: "shadow-none",
          hover: "shadow-none",
          focus: "focus:opacity-[0.85] focus:shadow-none",
          active: "active:opacity-[0.85] active:shadow-none",
        },
      },
      gradient: {
        white: {
          backgroud: "bg-white",
          color: "text-blue-gray-900",
          shadow: "shadow-none",
          hover: "shadow-none",
          focus: "focus:opacity-[0.85] focus:shadow-none",
          active: "active:opacity-[0.85] active:shadow-none",
        },
        "blue-gray": {
          backgroud: "bg-gradient-to-tr from-blue-gray-600 to-blue-gray-400",
          color: "text-white",
          shadow: "shadow-none",
          hover: "shadow-none",
          active: "active:opacity-[0.85]",
        },
        gray: {
          backgroud:
            "bg-gradient-to-b  from-[#313135] to-gray-900 dark:from-gray-200 dark:to-gray-300",
          color: "text-white",
          shadow: "shadow-none",
          hover: "shadow-none",
          active: "active:opacity-[0.85]",
        },
        brown: {
          backgroud: "bg-gradient-to-tr from-brown-600 to-brown-400",
          color: "text-white",
          shadow: "shadow-none",
          hover: "shadow-none",
          active: "active:opacity-[0.85]",
        },
        "deep-orange": {
          backgroud:
            "bg-gradient-to-tr from-deep-orange-600 to-deep-orange-400",
          color: "text-white",
          shadow: "shadow-none",
          hover: "shadow-none",
          active: "active:opacity-[0.85]",
        },
        orange: {
          backgroud: "bg-gradient-to-tr from-orange-600 to-orange-400",
          color: "text-white",
          shadow: "shadow-none",
          hover: "shadow-none",
          active: "active:opacity-[0.85]",
        },
        amber: {
          backgroud: "bg-gradient-to-tr from-amber-600 to-amber-400",
          color: "text-black",
          shadow: "shadow-none",
          hover: "shadow-none",
          active: "active:opacity-[0.85]",
        },
        yellow: {
          backgroud: "bg-gradient-to-tr from-yellow-600 to-yellow-400",
          color: "text-black",
          shadow: "shadow-none",
          hover: "shadow-none",
          active: "active:opacity-[0.85]",
        },
        lime: {
          backgroud: "bg-gradient-to-tr from-lime-600 to-lime-400",
          color: "text-black",
          shadow: "shadow-none",
          hover: "shadow-none",
          active: "active:opacity-[0.85]",
        },
        "light-green": {
          backgroud:
            "bg-gradient-to-tr from-light-green-600 to-light-green-400",
          color: "text-white",
          shadow: "shadow-none",
          hover: "shadow-none",
          active: "active:opacity-[0.85]",
        },
        green: {
          backgroud: "bg-gradient-to-tr from-green-600 to-green-400",
          color: "text-white",
          shadow: "shadow-none",
          hover: "shadow-none",
          active: "active:opacity-[0.85]",
        },
        teal: {
          backgroud: "bg-gradient-to-tr from-primary-600 to-primary-400",
          color: "text-white",
          shadow: "shadow-none",
          hover: "shadow-none",
          active: "active:opacity-[0.85]",
        },
        cyan: {
          backgroud: "bg-gradient-to-tr from-cyan-600 to-cyan-400",
          color: "text-white",
          shadow: "shadow-none",
          hover: "shadow-none",
          active: "active:opacity-[0.85]",
        },
        "light-blue": {
          backgroud: "bg-gradient-to-tr from-light-blue-600 to-light-blue-400",
          color: "text-white",
          shadow: "shadow-none",
          hover: "shadow-none",
          active: "active:opacity-[0.85]",
        },
        blue: {
          backgroud: "bg-gradient-to-tr from-blue-600 to-blue-400",
          color: "text-white",
          shadow: "shadow-none",
          hover: "shadow-none",
          active: "active:opacity-[0.85]",
        },
        indigo: {
          backgroud: "bg-gradient-to-tr from-indigo-600 to-indigo-400",
          color: "text-white",
          shadow: "shadow-none",
          hover: "shadow-none",
          active: "active:opacity-[0.85]",
        },
        "deep-purple": {
          backgroud:
            "bg-gradient-to-tr from-deep-purple-600 to-deep-purple-400",
          color: "text-white",
          shadow: "shadow-none",
          hover: "shadow-none",
          active: "active:opacity-[0.85]",
        },
        purple: {
          backgroud: "bg-gradient-to-tr from-purple-600 to-purple-400",
          color: "text-white",
          shadow: "shadow-none",
          hover: "shadow-none",
          active: "active:opacity-[0.85]",
        },
        pink: {
          backgroud: "bg-gradient-to-tr from-pink-600 to-pink-400",
          color: "text-white",
          shadow: "shadow-none",
          hover: "shadow-none",
          active: "active:opacity-[0.85]",
        },
        red: {
          backgroud: "bg-gradient-to-tr from-red-600 to-red-400",
          color: "text-white",
          shadow: "shadow-none",
          hover: "shadow-none",
          active: "active:opacity-[0.85]",
        },
      },
      outlined: {
        white: {
          border: "border border-white",
          color: "text-white",
          hover: "hover:opacity-75",
          focus: "focus:ring focus:ring-white/50",
          active: "active:opacity-[0.85]",
        },
        "blue-gray": {
          border: "border border-blue-gray-600",
          color: "text-blue-gray-600",
          hover: "hover:opacity-75",
          focus: "focus:ring focus:ring-blue-gray-200",
          active: "active:opacity-[0.85]",
        },
        gray: {
          border: "border border-gray-200",
          color: "text-gray-800",
          hover: "hover:bg-gray-100",
          focus: "focus:ring focus:ring-gray-200",
          active: "active:opacity-[0.85]",
        },
        brown: {
          border: "border border-brown-600",
          color: "text-brown-600",
          hover: "hover:opacity-75",
          focus: "focus:ring focus:ring-brown-200",
          active: "active:opacity-[0.85]",
        },
        "deep-orange": {
          border: "border border-deep-orange-600",
          color: "text-deep-orange-600",
          hover: "hover:opacity-75",
          focus: "focus:ring focus:ring-deep-orange-200",
          active: "active:opacity-[0.85]",
        },
        orange: {
          border: "border border-orange-600",
          color: "text-orange-600",
          hover: "hover:opacity-75",
          focus: "focus:ring focus:ring-orange-200",
          active: "active:opacity-[0.85]",
        },
        amber: {
          border: "border border-amber-600",
          color: "text-amber-600",
          hover: "hover:opacity-75",
          focus: "focus:ring focus:ring-amber-200",
          active: "active:opacity-[0.85]",
        },
        yellow: {
          border: "border border-yellow-600",
          color: "text-yellow-600",
          hover: "hover:opacity-75",
          focus: "focus:ring focus:ring-yellow-200",
          active: "active:opacity-[0.85]",
        },
        lime: {
          border: "border border-lime-600",
          color: "text-lime-600",
          hover: "hover:opacity-75",
          focus: "focus:ring focus:ring-lime-200",
          active: "active:opacity-[0.85]",
        },
        "light-green": {
          border: "border border-light-green-600",
          color: "text-light-green-600",
          hover: "hover:opacity-75",
          focus: "focus:ring focus:ring-light-green-200",
          active: "active:opacity-[0.85]",
        },
        green: {
          border: "border border-green-600",
          color: "text-green-600",
          hover: "hover:opacity-75",
          focus: "focus:ring focus:ring-green-200",
          active: "active:opacity-[0.85]",
        },
        teal: {
          border: "border border-teal-600",
          color: "text-teal-600",
          hover: "hover:opacity-75",
          focus: "focus:ring focus:ring-teal-200",
          active: "active:opacity-[0.85]",
        },
        cyan: {
          border: "border border-cyan-600",
          color: "text-cyan-600",
          hover: "hover:opacity-75",
          focus: "focus:ring focus:ring-cyan-200",
          active: "active:opacity-[0.85]",
        },
        "light-blue": {
          border: "border border-light-blue-600",
          color: "text-light-blue-600",
          hover: "hover:opacity-75",
          focus: "focus:ring focus:ring-light-blue-200",
          active: "active:opacity-[0.85]",
        },
        blue: {
          border: "border border-blue-600",
          color: "text-blue-600",
          hover: "hover:opacity-75",
          focus: "focus:ring focus:ring-blue-200",
          active: "active:opacity-[0.85]",
        },
        indigo: {
          border: "border border-indigo-600",
          color: "text-indigo-600",
          hover: "hover:opacity-75",
          focus: "focus:ring focus:ring-indigo-200",
          active: "active:opacity-[0.85]",
        },
        "deep-purple": {
          border: "border border-deep-purple-600",
          color: "text-deep-purple-600",
          hover: "hover:opacity-75",
          focus: "focus:ring focus:ring-deep-purple-200",
          active: "active:opacity-[0.85]",
        },
        purple: {
          border: "border border-purple-600",
          color: "text-purple-600",
          hover: "hover:bg-purple-100 dark:hover:!bg-blue-gray-900",
          focus: "focus:ring focus:ring-purple-200",
          active: "active:opacity-[0.85]",
        },
        pink: {
          border: "border border-pink-600",
          color: "text-pink-600",
          hover: "hover:opacity-75",
          focus: "focus:ring focus:ring-pink-200",
          active: "active:opacity-[0.85]",
        },
        red: {
          border: "border border-red-500",
          color: "text-red-500",
          hover: "hover:opacity-75",
          focus: "focus:ring focus:ring-red-200",
          active: "active:opacity-[0.85]",
        },
      },
      text: {
        white: {
          color: "text-white",
          hover: "hover:bg-white/10",
          active: "active:bg-white/30",
        },
        "blue-gray": {
          color: "text-blue-gray-600",
          hover: "hover:bg-blue-gray-600/10",
          active: "active:bg-blue-gray-600/30",
        },
        gray: {
          color: "text-gray-600",
          hover: "hover:bg-gray-600/10",
          active: "active:bg-gray-600/30",
        },
        brown: {
          color: "text-brown-600",
          hover: "hover:bg-brown-600/10",
          active: "active:bg-brown-600/30",
        },
        "deep-orange": {
          color: "text-deep-orange-600",
          hover: "hover:bg-deep-orange-600/10",
          active: "active:bg-deep-orange-600/30",
        },
        orange: {
          color: "text-orange-600",
          hover: "hover:bg-orange-600/10",
          active: "active:bg-orange-600/30",
        },
        amber: {
          color: "text-amber-600",
          hover: "hover:bg-amber-600/10",
          active: "active:bg-amber-600/30",
        },
        yellow: {
          color: "text-yellow-600",
          hover: "hover:bg-yellow-600/10",
          active: "active:bg-yellow-600/30",
        },
        lime: {
          color: "text-lime-600",
          hover: "hover:bg-lime-600/10",
          active: "active:bg-lime-600/30",
        },
        "light-green": {
          color: "text-light-green-600",
          hover: "hover:bg-light-green-600/10",
          active: "active:bg-light-green-600/30",
        },
        green: {
          color: "text-green-600",
          hover: "hover:bg-green-600/10",
          active: "active:bg-green-600/30",
        },
        teal: {
          color: "text-teal-600",
          hover: "hover:bg-teal-600/10",
          active: "active:bg-teal-600/30",
        },
        cyan: {
          color: "text-cyan-600",
          hover: "hover:bg-cyan-600/10",
          active: "active:bg-cyan-600/30",
        },
        "light-blue": {
          color: "text-light-blue-600",
          hover: "hover:bg-light-blue-600/10",
          active: "active:bg-light-blue-600/30",
        },
        blue: {
          color: "text-blue-600",
          hover: "hover:bg-blue-600/10",
          active: "active:bg-blue-600/30",
        },
        indigo: {
          color: "text-indigo-600",
          hover: "hover:bg-indigo-50",
          active: "active:bg-indigo-600/30",
        },
        "deep-purple": {
          color: "text-deep-purple-600",
          hover: "hover:bg-deep-purple-600/10",
          active: "active:bg-deep-purple-600/30",
        },
        purple: {
          color: "text-purple-600",
          hover: "hover:bg-purple-600/10",
          active: "active:bg-purple-600/30",
        },
        pink: {
          color: "text-pink-600",
          hover: "hover:bg-pink-600/10",
          active: "active:bg-pink-600/30",
        },
        red: {
          color: "text-red-600",
          hover: "hover:bg-red-600/10",
          active: "active:bg-red-600/30",
        },
      },
    },
  },
};
